export default __webpack_public_path__ + "static/media/clicka-client.e45d5413.png";